import { useFlags } from 'launchdarkly-react-client-sdk'
import { useLegacyPremiumsHref } from 'hooks/useLegacyPremiumsHref'
import { useTranslation } from 'react-i18next'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { Component } from '@cms-max/medicare-api-sdk'

const backToPremiumsElementId = 'premiums_backtopremiums_click'

/**
 * Returns a breadcrumb that will go to legacy when the useNewPremiumsPay feature flag is off.
 * This component should be deprecated and replaced with the non-feature flagged BackToPremiumsBreadcrumb
 * once premiums is live in production
 */
export function BackToPremiumsBreadcrumbFeatureFlagged () {
  const { t } = useTranslation('easyPaySummary')
  const flags = useFlags()
  const legacyPremiumsHref = useLegacyPremiumsHref()
  const url = flags?.useNewPremiumsPay ? '/premiums' : legacyPremiumsHref
  const isInternal = Boolean(flags?.useNewPremiumsPay)

  return (
    <BreadCrumb
      navAriaLabel={t('backToPremiums')}
      backButtonText={t('backToPremiums')}
      backButtonLink={url}
      linkIsExternal={!isInternal}
      width='wide'
      siteActivityProps={{
        core: {
          component: Component.Premiums,
          elementId: backToPremiumsElementId,
          coreClickData: {
            linkText: t('backToPremiums'),
            linkUrl: url
          }
        }
      }}
    />
  )
}

export function BackToPremiumsBreadcrumb () {
  const { t } = useTranslation('easyPaySummary')

  return (
    <BreadCrumb
      navAriaLabel={t('backToPremiums')}
      backButtonText={t('backToPremiums')}
      backButtonLink='/premiums'
      width='wide'
      siteActivityProps={{
        core: {
          component: Component.Premiums,
          elementId: backToPremiumsElementId,
          coreClickData: {
            linkText: t('backToPremiums'),
            linkUrl: '/premiums'
          }
        }
      }}
    />
  )
}
